export enum EditingSide {
	Start = "start",
	End = "end",
}
